export default "__VITE_ASSET__3276474a__"